export default {
	'targetOffsetTop' : 0,
	'targetOffsetTop_stu':false
}





// WEBPACK FOOTER //
// ./src/store/bzgqy_store.js